import { useCallback, useSyncExternalStore } from 'react';

import { getActiveScope, setActiveScope as setActiveScopeState, subscribeToActiveScope } from '~/services/activeScope';

export const useActiveScope = () => {
  const activeScope = useSyncExternalStore(subscribeToActiveScope, getActiveScope, getActiveScope);

  const setActiveScope = useCallback((nextScope: string | null | undefined) => {
    return setActiveScopeState(nextScope);
  }, []);

  return {
    activeScope,
    setActiveScope,
  };
};
